module.exports = __webpack_public_path__ + "static/media/91.9ed03626.png";